import { render, staticRenderFns } from "./TalkStatistics.vue?vue&type=template&id=5ccbce1c&scoped=true&"
import script from "./TalkStatistics.vue?vue&type=script&lang=js&"
export * from "./TalkStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccbce1c",
  null
  
)

export default component.exports